import { openBlock, createElementBlock, createElementVNode } from 'vue';

function render(_ctx, _cache) {
  return (openBlock(), createElementBlock("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    fill: "currentColor",
    "aria-hidden": "true"
  }, [
    createElementVNode("g", { "clip-path": "url(#clip0_9_2121)" }, [
      createElementVNode("path", {
        "fill-rule": "evenodd",
        d: "M10 18a8 8 0 100-16 8 8 0 000 16zm3.25-7.25a.75.75 0 000-1.5H8.66l2.1-1.95a.75.75 0 10-1.02-1.1l-3.5 3.25a.75.75 0 000 1.1l3.5 3.25a.75.75 0 001.02-1.1l-2.1-1.95h4.59z",
        "clip-rule": "evenodd"
      })
    ]),
    createElementVNode("defs", null, [
      createElementVNode("clipPath", { id: "clip0_9_2121" }, [
        createElementVNode("path", { d: "M0 0h20v20H0z" })
      ])
    ])
  ]))
}

export { render as default };
